import {IsConfirmedConfiguration, IsConfirmedForm} from '../../../../fields/isConfirmed/types'
import {OrderStatus} from '../../../types'
import {CreateFormInput} from '../types'

export const buildIsConfirmedForm = ({
  order
}: CreateFormInput<IsConfirmedConfiguration>): IsConfirmedForm => {
  return {
    /**
     * Maps whether the order is confirmed by customer (SAP OrderReason 01 or 11).
     *
     * SAP OrderReason values:
     * - OrderReason 01: Order confirmed by customer and dispatcher → OrderStatus.Confirmed
     * - OrderReason 11: Order pending dispatch approval with customer confirmation → OrderStatus.Pending
     * - OrderReason 12: Order pending dispatch approval without customer confirmation → OrderStatus.Pending
     *
     * Note: OrderReason is not available in the order payload, so we derive the confirmation
     * state from OrderStatus. We only map OrderStatus.Confirmed because:
     * - OrderReason 11 and 12 both result in OrderStatus.Pending
     * - Orders with OrderStatus.Pending (covering both 11 and 12) are not editable
     * - Therefore, we skip the edge case of OrderReason 11 since it cannot be modified anyway
     */
    isConfirmedOrder: order.orderStatus === OrderStatus.Confirmed
  }
}
